import { ClaimOwnerCapacity } from '@dispatch/shared/types';
import { Section, TextField } from '@dispatch/web/ui';
import { Grid, InputAdornment, Typography } from '@mui/material';
import { Control, FieldErrors } from 'react-hook-form';

const styles = {
  item: {
    '.MuiGrid-item': {
      paddingLeft: '24px',
    },
  },
};

export const ClaimCapacity = ({
  control,
  errors,
  claimOwnerCapacity,
  isReadOnly = false,
}: {
  control: Control;
  errors: FieldErrors;
  claimOwnerCapacity?: ClaimOwnerCapacity;
  isReadOnly?: boolean;
}) => {
  return (
    <div data-testid="claimOwnerCapacity">
      <Section title="Claim Capacity">
        <Grid container spacing={1} gap={2} padding="10px 25px">
          <Grid container xs={5} spacing={1}>
            <Grid container item>
              <Grid item xs={12}>
                <Typography component="p" fontSize="14px">
                  Handler
                </Typography>
              </Grid>
            </Grid>
            <Grid container item spacing={2} sx={styles.item}>
              <Grid item xs={8}>
                <TextField
                  id="claimCapacity"
                  name="generalInformation.claimCapacity"
                  label="Field"
                  type="number"
                  control={control}
                  defaultValue={0}
                  inputProps={{
                    readOnly: false,
                  }}
                  error={
                    errors?.['generalInformation']?.['claimCapacity']?.message
                  }
                  disabled={isReadOnly}
                />
              </Grid>
            </Grid>
            <Grid container item spacing={2} sx={styles.item}>
              <Grid item xs={8}>
                <TextField
                  id="virtualClaimCapacity"
                  name="generalInformation.virtualClaimCapacity"
                  label="Virtual"
                  type="number"
                  control={control}
                  inputProps={{
                    readOnly: false,
                  }}
                  error={
                    errors?.['generalInformation']?.['virtualClaimCapacity']
                      ?.message
                  }
                  disabled={isReadOnly}
                />
              </Grid>
            </Grid>
            <Grid container item spacing={2} sx={styles.item}>
              <Grid item xs={8}>
                <TextField
                  id="complexLossClaimCapacity"
                  name="generalInformation.complexLossClaimCapacity"
                  label="Complex Loss - Weekly"
                  type="number"
                  control={control}
                  inputProps={{
                    readOnly: false,
                  }}
                  error={
                    errors?.['generalInformation']?.['complexLossClaimCapacity']
                      ?.message
                  }
                  disabled={isReadOnly}
                />
              </Grid>
            </Grid>
            <Grid container item spacing={2} sx={styles.item}>
              <Grid item xs={8} height="64px"></Grid>
            </Grid>
          </Grid>

          <Grid container xs={7} spacing={1}>
            <Grid container item>
              <Grid item xs={12}>
                <Typography component="p" fontSize="14px">
                  Owner
                </Typography>
              </Grid>
            </Grid>
            <Grid container item spacing={2} sx={styles.item}>
              <Grid item xs={6}>
                <TextField
                  id="claimOwner.onSunday"
                  name="claimOwner.onSunday"
                  label="Sunday"
                  type="number"
                  control={control}
                  defaultValue={0}
                  inputProps={{
                    readOnly: false,
                    startAdornment: (
                      <InputAdornment position="start">
                        ({claimOwnerCapacity?.initialOnSunday || 0})
                      </InputAdornment>
                    ),
                  }}
                  error={errors?.['claimOwner']?.['onSunday']?.message}
                  disabled={isReadOnly}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="claimOwner.onMonday"
                  name="claimOwner.onMonday"
                  label="Monday"
                  type="number"
                  control={control}
                  defaultValue={0}
                  inputProps={{
                    readOnly: false,
                    startAdornment: (
                      <InputAdornment position="start">
                        ({claimOwnerCapacity?.initialOnMonday || 0})
                      </InputAdornment>
                    ),
                  }}
                  error={errors?.['claimOwner']?.['onMonday']?.message}
                  disabled={isReadOnly}
                />
              </Grid>
            </Grid>
            <Grid container item spacing={2} sx={styles.item}>
              <Grid item xs={6}>
                <TextField
                  id="claimOwner.onTuesday"
                  name="claimOwner.onTuesday"
                  label="Tuesday"
                  type="number"
                  control={control}
                  defaultValue={0}
                  inputProps={{
                    readOnly: false,
                    startAdornment: (
                      <InputAdornment position="start">
                        ({claimOwnerCapacity?.initialOnTuesday || 0})
                      </InputAdornment>
                    ),
                  }}
                  error={errors?.['claimOwner']?.['onTuesday']?.message}
                  disabled={isReadOnly}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="claimOwner.onWednesday"
                  name="claimOwner.onWednesday"
                  label="Wednesday"
                  type="number"
                  control={control}
                  defaultValue={0}
                  inputProps={{
                    readOnly: false,
                    startAdornment: (
                      <InputAdornment position="start">
                        ({claimOwnerCapacity?.initialOnWednesday || 0})
                      </InputAdornment>
                    ),
                  }}
                  error={errors?.['claimOwner']?.['onWednesday']?.message}
                  disabled={isReadOnly}
                />
              </Grid>
            </Grid>
            <Grid container item spacing={2} sx={styles.item}>
              <Grid item xs={6}>
                <TextField
                  id="claimOwner.onThursday"
                  name="claimOwner.onThursday"
                  label="Thursday"
                  type="number"
                  control={control}
                  defaultValue={0}
                  inputProps={{
                    readOnly: false,
                    startAdornment: (
                      <InputAdornment position="start">
                        ({claimOwnerCapacity?.initialOnThursday || 0})
                      </InputAdornment>
                    ),
                  }}
                  error={errors?.['claimOwner']?.['onThursday']?.message}
                  disabled={isReadOnly}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="claimOwner.onFriday"
                  name="claimOwner.onFriday"
                  label="Friday"
                  type="number"
                  control={control}
                  defaultValue={0}
                  inputProps={{
                    readOnly: false,
                    startAdornment: (
                      <InputAdornment position="start">
                        ({claimOwnerCapacity?.initialOnFriday || 0})
                      </InputAdornment>
                    ),
                  }}
                  error={errors?.['claimOwner']?.['onFriday']?.message}
                  disabled={isReadOnly}
                />
              </Grid>
            </Grid>
            <Grid container item spacing={2} sx={styles.item}>
              <Grid item xs={6}>
                <TextField
                  id="claimOwner.onSaturday"
                  name="claimOwner.onSaturday"
                  label="Saturday"
                  type="number"
                  control={control}
                  defaultValue={0}
                  inputProps={{
                    readOnly: false,
                    startAdornment: (
                      <InputAdornment position="start">
                        ({claimOwnerCapacity?.initialOnSaturday || 0})
                      </InputAdornment>
                    ),
                  }}
                  disabled={isReadOnly}
                  error={errors?.['claimOwner']?.['onSaturday']?.message}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="claimOwner.maxWeeklyCapacity"
                  name="claimOwner.maxWeeklyCapacity"
                  label="Max Weekly Capacity"
                  type="number"
                  control={control}
                  defaultValue={0}
                  error={errors?.['claimOwner']?.['maxWeeklyCapacity']?.message}
                  disabled={isReadOnly}
                  inputProps={{
                    readOnly: false,
                    startAdornment: (
                      <InputAdornment position="start">
                        ({claimOwnerCapacity?.initialMaxWeeklyCapacity || 0})
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Section>
    </div>
  );
};
